// src/components/SideMenu/SideMenu.jsx
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import menu from '../../assets/menu.png';
import './SideMenu.css';

const SideMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* Botón siempre visible */}
      <div className="menu-button" role="button" aria-label="Menú de navegación">
        <img src={menu} alt="menu" onClick={() => setMenuOpen(prev => !prev)} />
      </div>

      {/* Panel y overlay animados */}
      <div className={`menu-wrapper ${menuOpen ? 'open' : ''}`}>
        {menuOpen && (
          <div
            className="menu-overlay"
            onClick={() => setMenuOpen(false)}
            aria-label="Cerrar menú lateral"
          />
        )}
        <div className="menu-panel">
          {location.pathname === '/cauchari' && (
            <button className="menu-btn-dark" onClick={() => { setMenuOpen(false); navigate('/cauchari_cna'); }}>Ir a CNA</button>
          )}
          <button className="menu-btn-dark" onClick={() => { setMenuOpen(false); navigate('/'); }}>Salir</button>
          
        </div>
      </div>
    </>
  );
};


export default SideMenu;